import Layout from 'src/components/Layout';
import ActionRequiredInvoice from './ActionRequiredInvoice';
import GLSummaryGrid from './GLSummaryGrid';

const ActionRequiredInvoicesMain = () => (
  <Layout>
    <div style={{ height: 'calc(100vh - 95px)' }}>
      <GLSummaryGrid />
      <ActionRequiredInvoice />
    </div>
  </Layout>
);

export default ActionRequiredInvoicesMain;
